/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Business Events logic module.
 * Handles business event management including event creation, retrieval,
 * participating company management, requirements handling, and attendance operations.
 * @module logic/businessEvents
 */

import {
  fetchUserRoleData,
  showEventCreatedSuccess,
} from "../../utils/eventApi.js";

export { showEventCreatedSuccess };

export const getUserRoleData = fetchUserRoleData;

export {
  getBusinessEvents,
  getActiveBusinessEvents,
  getAllBusinessEvents,
  getBusinessEventsByYear,
  getEventDetails,
  getBusinessEventsForBuyer,
  getData,
} from "./businessEventsQueries.js";

export {
  getParticipatingCompanies,
  getParticipatingCompaniesAdmin,
  getParticipatingCompaniesPage,
  getParticipatingCompanyAdminDetail,
  getBuyerCompanies,
  addParticipatingCompanyToEvent,
  updateParticipatingCompany,
  deleteParticipatingCompany,
  addRequirementToParticipant,
  deleteRequirementFromParticipant,
} from "./businessEventsParticipation.js";

export {
  submitEvent,
  initializeEventCreation,
  cancelAttendance,
  updateAttendanceCancelledStatus,
  validatePreRegister,
} from "./businessEventsMutations.js";

export {
  processRequirementsExcelFile,
  fetchValidateRequirements,
  getValidateRequirements,
} from "./businessEventsRequirements.js";
